module.exports = __webpack_public_path__ + "img/BB 03.5e6d739f.png";